import './font-styles.css';
import UhcSansRegularOtf from '../../Assets/fonts/UHCSans-Regular.otf';
import UhcSansMediumWoff2 from '../../Assets/fonts/UHCSans-Medium.woff2';
// export const Bold = 'AbyssEnterpriseSansVF-Bold, Helvetica, Arial, Verdana, Tahoma, sans-serif';
// export const Regular = 'AbyssEnterpriseSansVF-Regular, Helvetica, Arial, Verdana, Tahoma, sans-serif';
// export const Medium = 'AbyssEnterpriseSansVF-Medium, Helvetica, Arial, Verdana, Tahoma, sans-serif';
// export const SemiBold = 'AbyssEnterpriseSansVF-SemiBold, Helvetica, Arial, Verdana, Tahoma, sans-serif';

const MAC_FONT_METRIC_FACES = [
  {
    family: 'UHCSans-Regular-header',
    sourceUrl: UhcSansRegularOtf,
    descriptors: {
      ascentOverride: '97.9%',
      descentOverride: '25%',
      lineGapOverride: '0%'
    }
  },
  {
    // UHCSans-Medium: hhea ascent differs on Mac vs Windows.
    // Override to win value so Mac matches Windows rendering.
    family: 'UHCSans-Medium-header',
    sourceUrl: UhcSansMediumWoff2,
    descriptors: {
      ascentOverride: '78%',
      descentOverride: '25%',
      lineGapOverride: '0%'
    }
  }
] as const;

let hasAppliedMacFontMetricsFix = false;

const isMacOsBrowser = (): boolean => {
  if (typeof navigator === 'undefined') {
    return false;
  }

  const navigatorWithUaData = navigator as Navigator & { userAgentData?: { platform?: string } };
  const platform = navigatorWithUaData.userAgentData?.platform || navigator.platform || '';
  const userAgent = navigator.userAgent || '';

  return /Mac|iPhone|iPad|iPod/i.test(platform) || /Macintosh|Mac OS X|iPhone|iPad|iPod/i.test(userAgent);
};

const applyMacFontMetricsFix = (): void => {
  if (typeof document === 'undefined' || typeof FontFace === 'undefined' || !isMacOsBrowser()) {
    return;
  }

  if (hasAppliedMacFontMetricsFix) {
    return;
  }
  hasAppliedMacFontMetricsFix = true;

  MAC_FONT_METRIC_FACES.forEach(({ family, sourceUrl, descriptors }) => {
    const fontFace = new FontFace(family, `url(${sourceUrl})`, descriptors);
    document.fonts.add(fontFace);
    void fontFace.load().catch(() => {
      // Keep existing base @font-face behavior when a metric-override face fails to load.
    });
  });
};

applyMacFontMetricsFix();


export const UhcRegular = 'UHCSans-Regular, Helvetica, Arial, Verdana, Tahoma, sans-serif';
export const UhcMedium = 'UHCSans-Medium, Helvetica, Arial, Verdana, Tahoma, sans-serif';
/** Use in AppHeader only — applies Mac metric-override alias, falls back to global on Windows. */
export const UhcMediumHeader = "'UHCSans-Medium-header', UHCSans-Medium, Helvetica, Arial, Verdana, Tahoma, sans-serif";
export const UhcSemiBold = 'UHCSans-SemiBold, Helvetica, Arial, Verdana, Tahoma, sans-serif';
export const UhcBold = 'UHCSans-Bold, Helvetica, Arial, Verdana, Tahoma, sans-serif';
export const UhcSans = 'UHCSans, Helvetica, Arial, Verdana, Tahoma, sans-serif';
export const Regular = 'UHCSans-Regular, Helvetica, Arial, Verdana, Tahoma, sans-serif';
export const Medium = 'UHCSans-Medium, Helvetica, Arial, Verdana, Tahoma, sans-serif';
export const SemiBold = 'UHCSans-SemiBold, Helvetica, Arial, Verdana, Tahoma, sans-serif';
export const Bold = 'UHCSans-Bold, Helvetica, Arial, Verdana, Tahoma, sans-serif';